import { render } from "./BetreuungDetails.vue?vue&type=template&id=172cfcf0&scoped=true"
import script from "./BetreuungDetails.vue?vue&type=script&lang=js"
export * from "./BetreuungDetails.vue?vue&type=script&lang=js"

import "./BetreuungDetails.vue?vue&type=style&index=0&id=172cfcf0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-172cfcf0"]])

export default __exports__